export default {
      id: "active-client-usage",
      viewBox: "0 0 12 12",
      url: "assets/" + "sprite.svg#active-client-usage",
      toString: function () {
        return this.url;
      }
    }